import Container from '@/components/@base/container';
import cn from '@/lib/clsxm';


const ThreeDotLoading = ({className}:{className?:string}) => {
  return (
    <Container className={cn('loading-dots fixed z-10 bottom-6', className)}>
      <span className='loading-dot'/>
      <span className='loading-dot'/>
      <span className='loading-dot'/>
    </Container>
  );
};

export default ThreeDotLoading;